<script lang="ts">
	import type { EmblaCarouselType } from 'embla-carousel';
	import Carousel from '../carousel.svelte';
	import GalleryIndicator from '../galleryIndicator.svelte';
	import ArrowLeft from '../icons/arrowLeft.svelte';
	import ArrowRight from '../icons/arrowRight.svelte';
	import { fly } from 'svelte/transition';
	import type { Snippet } from 'svelte';

	interface Props {
		count?: number;
		active?: number;
		theme?: 'light' | 'dark';
		children: Snippet;
		class?: string;
	}

	let {
		count = 0,
		active = $bindable(0),
		theme = 'light',
		children,
		class: className
	}: Props = $props();

	let embla = $state<EmblaCarouselType>();

	export function next() {
		if (embla) {
			embla.scrollNext();
		}
	}

	export function previous() {
		if (embla) {
			embla.scrollPrev();
		}
	}

	let indicatorButtonClasses = $derived(
		theme === 'light' ? 'border-brown-2 hover:bg-brown-2' : 'border-stone-5 hover:bg-stone-5'
	);
	let indicatorIconClasses = $derived(
		theme === 'light'
			? 'text-brown-2 group-hover:text-stone-5'
			: 'text-stone-5 group-hover:text-brown-2'
	);
</script>

<div class="w-screen overflow-x-hidden px-8 py-9 {className}">
	<Carousel
		autoplay
		autoplayDuration={4000}
		align="center"
		bind:embla
		bind:currentIndex={active}
		overflow
		loop
		class="flex"
	>
		{@render children()}
	</Carousel>

	<div class="mt-8 flex justify-center lg:mt-12">
		<div class="relative flex h-8 flex-col justify-center">
			<button
				transition:fly={{ x: -48 }}
				class="group absolute left-0 top-0 z-10 flex h-8 w-8 -translate-x-full items-center justify-center rounded-full border transition-colors max-lg:hidden {indicatorButtonClasses}"
				onclick={previous}
			>
				<ArrowLeft class="h-4 w-4 {indicatorIconClasses}" />
			</button>

			<GalleryIndicator
				bind:active
				buttonTransform={false}
				{count}
				onchange={(index) => embla?.scrollTo(index)}
				color={theme === 'light' ? 'brown-2' : 'stone-5'}
			/>

			<button
				transition:fly={{ x: 48 }}
				class="group absolute right-0 top-0 z-10 flex h-8 w-8 translate-x-full items-center justify-center rounded-full border transition-colors max-lg:hidden {indicatorButtonClasses}"
				onclick={next}
			>
				<ArrowRight class="h-4 w-4 {indicatorIconClasses}" />
			</button>
		</div>
	</div>
</div>
